import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatOption } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { AppService } from 'src/app/app.service';
import { EditorComponent } from 'src/app/editor/editor.component';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../qms.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';

@Component({
  selector: 'app-activity-au-trail',
  templateUrl: './activity-au-trail.component.html',
  styleUrls: ['./activity-au-trail.component.scss']
})
export class ActivityAuTrailComponent {

  key: any;
  noData: boolean = false;
  reportObj: any = {};
  switchUserLog: any = [];
  constructor(private readonly appService: AppService, public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef, public dialog: MatDialog, private readonly snackBar: MatSnackBar, private readonly qmsService: qmsService) {

  }

  @ViewChild('dynAuditTrailPopup', { static: true }) dynAuditTrailPopup: TemplateRef<any>;
  visibleAuditTrailPopup: MatDialogRef<TemplateRef<any>>;
  auditTrailPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px', left: '5.8%' },
    maxWidth: '93vw',
  }

  openAuditTrail(activity: any) {
    this.auditTrail = activity;
    this.selectedTabIndex = 0;

    if (this.qmsService.moduleName == 'AU') {

      let tabName: string = '';

      if (activity.selectedTab == 'Annual Audit Schedule') {
        tabName = 'AU_SCHEDULE';
      } else if (activity.selectedTab == 'Audit Plan') {
        tabName = 'AU_PLAN';
      } else {
        tabName = 'AU_CONDUCT';
      }

      this.auditTrail.refNo = activity.AU_NO;
      this.auditTrail.gridName = tabName;
      this.auditTrail.report_And_Popup_Name = activity.selectedTab + ' Audit Trail';
    } else {

      let refNoMapping: Record<string, string> = { 'CR': 'CR_NO', 'CAPA': 'CAPA_NO', 'DV': 'DV_NO', 'IN': 'IN_NO', 'QI': 'QI_NO', 'CC': 'CC_NO', 'OOS': 'OOS_NO' };
      this.auditTrail.refNo = activity[refNoMapping[this.qmsService.moduleName]];
      this.auditTrail.gridName = this.qmsService.moduleName;
      this.auditTrail.report_And_Popup_Name = this.qmsService.moduleName + ' Audit Trail';
    }

    this.triggerTrail(this.auditTrail);
    this.visibleAuditTrailPopup = this.dialog.open(this.dynAuditTrailPopup, this.auditTrailPopupConfig);
  }

  cancelAuditPopup() {
    this.visibleAuditTrailPopup.close();
  }

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;
    this.noData = true;
    let refNoMapping: Record<string, string> = { 'CR': 'CR_NO', 'CAPA': 'CAPA_NO', 'DV': 'DV_NO', 'AU': 'AU_NO', 'IN': 'IN_NO', 'QI': 'QI_NO', 'CC': 'CC_NO', };

    if (this.qmsService.moduleName != 'AU') {
      if (this.tabIndex == 0) {
        this.auditTrail.refNo = this.auditTrail[refNoMapping[this.qmsService.moduleName]];
        this.auditTrail.gridName = this.qmsService.moduleName;
        this.auditTrail.report_And_Popup_Name = this.qmsService.moduleName + ' Audit Trail';
        this.triggerTrail(this.auditTrail);
      } else if (this.tabIndex == 1) {
        const obj = {

          groupId: this.auditTrail.GROUP_ID,
          module: this.qmsService.moduleName,
          refId: this.auditTrail[refNoMapping[this.qmsService.moduleName]]
        }
        this.trail(obj);
      }
    } else if (this.tabIndex == 0) {
      let tabName: string = '';

      if (this.auditTrail.selectedTab == 'Annual Audit Schedule') {
        tabName = 'AU_SCHEDULE';
      } else if (this.auditTrail.selectedTab == 'Audit Plan') {
        tabName = 'AU_PLAN';
      } else {
        tabName = 'AU_CONDUCT';
      }
      this.auditTrail.refNo = this.auditTrail.AU_NO;
      this.auditTrail.gridName = tabName;
      this.auditTrail.report_And_Popup_Name = this.auditTrail.selectedTab + ' Audit Trail';
      this.triggerTrail(this.auditTrail);
    } else if (this.tabIndex == 1) {
      const obj = {

        groupId: this.auditTrail.GROUP_ID,
        module: this.qmsService.moduleName,
        refId: this.auditTrail.AU_NO
      }
      this.trail(obj);
    }


    this.appService.getOneQmsSwitchUserLogVw(this.qmsService.moduleName, this.auditTrail.GROUP_ID, this.auditTrail[refNoMapping[this.qmsService.moduleName]]).subscribe((data: any) => {
      this.switchUserLog = data;
    })
  }

  columnSearchText: string = '';

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  htmlContent: any;
  isProcessing = true;
  @Input() auditTrail: any = {};

  triggerTrail(data: any) {
    this.auditTrail = data;
    this.getCall();
  }

  flexi: any;
  headers: any = []
  trail(obj: {}) {
    this.isProcessing = true;
    this.appService.getFlexibleFieldsAuditTrail(obj).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        console.log("RESPONSE →", response)
        if (response.length) {
          this.noData = false;
          this.flexi = response;
          this.collectionSize = this.flexi.length;
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.setPageFlexi(1, 0);
          for (let x = 0; x < this.flexi.length; x++) {
            if (x == 0) {
              this.headers = [];
              for (const element of this.flexi[x]) {
                this.headers.push(element.displayName);
                console.log(this.headers)
              }
            }
          }
        } else {
          this.noData = true;
        }
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPageFlexi(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.flexi.length, page, this.perPage, targetPage);
    this.pagedItemsFlexi = this.flexi.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCallFlexi(value: number) {
    this.perPage = value;
    this.setPageFlexi(this.pager.currentPage, 0);
  }

  setPagedOrSearchFlexi(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    if (this.flexi.length > 0) {
      this.pager = this.paginationService.getPager(this.flexi.length, page, this.perPage, targetPage);
      this.pagedItemsFlexi = this.flexi.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsFlexi = [];
    }
  }

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, columnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, columnName);
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.isProcessing = false;
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  grid: any = [];
  gridTemp: any;
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  pagedItemsFlexi: any[];
  error = '';

  getCall() {
    this.isProcessing = true;
    const primary_obj = {

      gridName: this.auditTrail.gridName,
      groupId: this.qmsService.selectedGroup
    }
    this.appService.usergridddynamicFieldsForAudittrails(primary_obj).subscribe({
      next: (response: any) => {
        response.orderByClause = response.orderByClause ? response.orderByClause : "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const isId: boolean = this.auditTrail.gridName !== 'TRAINING_BADGE' && this.auditTrail.gridName !== 'LOCATION_MASTER' && this.auditTrail.gridName !== 'SCHEDULED_JOBS' && this.auditTrail.gridName !== 'CODELISTS';

        const temp_obj: any = {

          gridName: this.auditTrail.gridName,
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          clobColumnlist: response.closblist ?? "",
          blobColumnlist: response.bloblist ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,

          ...(this.auditTrail.groupId && { au_Trail_groupId: this.auditTrail.groupId }),
          ...(this.auditTrail.activityRefNo && { au_Trail_ActivityRefNo: this.auditTrail.activityRefNo }),
          ...(this.auditTrail.formId_Audit_Trail && { formId_Audit_Trail: this.auditTrail.formId_Audit_Trail }),
          ...(this.auditTrail.report_Id_Audit_Trail && { report_Id_Audit_Trail: this.auditTrail.report_Id_Audit_Trail }),
          ...(this.auditTrail.productId_Audit_Trail && { productId_Audit_Trail: this.auditTrail.productId_Audit_Trail }),
          ...(this.auditTrail.codelist_Group_Audit_Trail && { codelist_Group_Audit_Trail: this.auditTrail.codelist_Group_Audit_Trail }),
          ...(this.auditTrail.form_SectionId_Audit_Trail && { form_SectionId_Audit_Trail: this.auditTrail.form_SectionId_Audit_Trail }),
          ...(this.auditTrail.form_TemplateId_Audit_Trail && { form_TemplateId_Audit_Trail: this.auditTrail.form_TemplateId_Audit_Trail }),
          [`auditTrail${isId ? 'Id' : 'Code'}`]: this.auditTrail.refNo?.toString() ?? null,
        }

        const secondary_obj = { ...this.auditTrail.secondary_obj, ...temp_obj };

        this.appService.getDynamicGridData(secondary_obj).subscribe({
          next: (response1: any) => {
            this.grid = response1;
            this.noData = response1;
            secondary_obj.columnsListarray = secondary_obj.columnsList.split(",");
            secondary_obj.fieldColumnarray = secondary_obj.fieldLabelsList.split(",");
            secondary_obj.invisibleColumnarray = secondary_obj.invisibleColumn.split(",");
            secondary_obj.fieldSizeListArray = secondary_obj.fieldSizeList.split(",");
            this.columnLists.columnsListarray = secondary_obj.columnsListarray;
            this.columnLists.fieldLabelsList = secondary_obj.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < secondary_obj.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": secondary_obj.fieldColumnarray[p],
                "width": secondary_obj.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = secondary_obj.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of secondary_obj.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            this.reportObj = { ...secondary_obj, ...primary_obj };
            this.dropDownForReport = this.columnLists?.fieldColumnarray?.map((item: any) => ({
              valueExp: item.fieldColumnarray,
              displayExp: item.fieldColumnarray
            }));

            let tableData = {
              tablename: secondary_obj.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const element of this.dataTypeList) {
                  if (element.columnName == this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                  }
                }
              }
              for (let i = 0; i < this.grid.length; i++) {
                for (const element of this.dataTypeList) {
                  if (element.fieldType == 'CHECKBOX') {
                    this.grid[i][element.columnName] = this.grid[i][element.columnName] == "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.grid;
            this.collectionSize = this.grid.length;
            this.totalPages = Math.ceil(this.grid.length / this.itemsPerPage);
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.grid.length, page, this.perPage, targetPage);
    this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  setPagedOrSearch(page: number, targetPage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.gridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.gridTemp.length, page, this.perPage, targetPage);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.grid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.grid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  searchValue2: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.gridTemp = this.grid;
      this.pager = this.paginationService.getPager(this.gridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.gridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      if (this.grid == undefined) {
        return this.grid;
      }
      if (!this.grid.length) {
        return this.grid;
      }
      if (filter) {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });
      } else {
        this.gridTemp = this.grid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedOrSearch(1, 0);
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.grid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBox: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBox = true;
      for (const element of this.grid) {
        element.childCheckBox = true;
      }
    } else {
      this.childCheckBox = false;
      for (const element of this.grid) {
        element.childCheckBox = false;
      }
    }
  }

  previousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousSelectedValue != undefined) {
        this.grid[this.previousSelectedValue].childCheckBox = false;
      }
      list.childCheckBox = true;
    } else {
      list.childCheckBox = false;
    }
    this.previousSelectedValue = idx;
  }

  refreshGridData() {
    this.getCall();
  }

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewerPdfPopup', { static: true }) viewerPdfPopup: TemplateRef<any>;
  visibleViewerPdfPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('viewerImagePopup', { static: true }) viewerImagePopup: TemplateRef<any>;
  visibleViewerImagePopup: MatDialogRef<TemplateRef<any>>;

  viewerPopupConfig = {
    width: '80%',
    height: '80%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  }

  excelPdfPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 2,
  };

  selectedColumns: any;
  dropDownForReport: any;
  isForExcel: boolean = false;
  popupDataTitle = { title: '' };
  pdfPageSizes: any = [];
  pdfPageSize: string = "";
  openReportPopup(item: any) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') || '{}');
    this.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
  }

  manuallyPicked: boolean;
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };

  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.selectedColumns.length > 30) {
      this.showSnackBar('Selected columns exceeded the limit. Limit 30, Selected ' + this.selectedColumns.length, 'E');
    } else {
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replaceAll(/[, ]/g, (match) => match === ',' ? '' : '_');


      let fileType = value == 'Excel' ? 'xlsx' : 'pdf';

      const fileName = `${this.auditTrail.report_And_Popup_Name.replaceAll(' ', '_')}_${formattedDate}.${fileType}`;

      if (value == 'Excel') {

        const excelObj = {
          ...this.reportObj, title: this.auditTrail.report_And_Popup_Name, columns: [],
          "informationTab": { "Report Name": this.auditTrail.report_And_Popup_Name, "Exported By": localStorage.getItem("loggedUserName") }
        }
        this.downloadExcelReport(excelObj, fileName);

      } else {
        const pdfObj = {
          ...this.reportObj, logoId: 0, title: this.auditTrail.report_And_Popup_Name, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.dropDownForReport.map((report: any) => report.valueExp)?.slice(0, 10).join(','), pdfPageSize: this.pdfPageSize, isSaveRep: 'N'
        }
        this.downloadPdfReport(pdfObj, fileName);
      }
    }
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openStaticReportPopup(reportType: string) {
    let refNoMapping: Record<string, string> = { 'CR': 'CR_NO', 'CAPA': 'CAPA_NO', 'DV': 'DV_NO', 'AU': 'AU_NO', 'IN': 'IN_NO', 'QI': 'QI_NO', 'CC': 'CC_NO', };

    this.excelPdf.tableOrView_Name = "ONEQMS_SWITCH_USER_LOG_VW";
    this.excelPdf.columnList_DB = "USER_ROLE,SWITCHED_FROM_USER,SWITCHED_TO_USER,SWITCHED_BY_USER,STATUS,REASON_FOR_SWITCH,CREATED_ON";
    this.excelPdf.columnList_Report = "User Role,Switched From,Switched To,Switched By,Status,Reason,Created On";
    this.excelPdf.whereClause_Report = " WHERE ORG_ID = " + this.message.getOrgId() + " AND MODULE = '" + this.qmsService.moduleName +
      "' AND GROUP_ID = " + this.auditTrail.GROUP_ID + " AND REF_NO = " + this.auditTrail[refNoMapping[this.qmsService.moduleName]];
    this.excelPdf.reportType = 'Static';
    this.excelPdf.orderByClause = ' CREATED_ON DESC';
    this.excelPdf.reportName = 'Switch User Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  extension: any;
  downloadDocument(list: any) {
    console.log(list);
    const contentData = "data:application/octet-stream;base64," + list.TEMPLATE;
    const downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = list.TEMPLATE_NAME + "." + list.TEMPLATE_EXTN;
    downloadLink.click();
  }

  cancelAddAndEditFunction() {
    this.visibleViewerPdfPopup.close();
  }

  cancelAddAndEditFunctionimage() {
    this.visibleViewerPdfPopup.close();
    this.visibleViewerImagePopup.close();
  }

  downloadDocuments(list: any, columnName: any) {
    debugger;
    this.visibleViewerPdfPopup = this.dialog.open(this.viewerPdfPopup, this.viewerPopupConfig);
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: columnName
    }

    this.appService.getDocumentToViewAudit(docObj).subscribe((data: any) => {
      console.log(data.headers);
      const header = data.headers.get('content-type');
      console.log(header);
      this.extension = null;
      if (header == 'image/x-png') {
        this.extension = 'png';
      } else if (header == 'application/pdf') {
        this.extension = 'pdf';
      } else if (header == 'text/plain') {
        this.extension = 'txt';
      } else if (header == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        this.extension = 'docx';
      } else if (header == 'application/octet-stream') {
        this.extension = 'xlsx';
      } else if (header == 'image/jpeg') {
        this.extension = 'jpg';
      }

      if (this.extension == 'jpg' || this.extension == 'jpeg' || this.extension == 'png' || this.extension == 'JPG' || this.extension == 'PNG' || this.extension == 'JPEG') {
        this.visibleViewerImagePopup = this.dialog.open(this.viewerImagePopup, this.auditTrailPopupConfig);
        let blob = new Blob([data.body], { type: "image/*" });
        let url = URL.createObjectURL(blob);
        let image: any = document.getElementById("picturewe");
        image.src = url;
      } else {
        this.loadDataInViewer(data, this.extension);
      }
    })
    this.isProcessing = false;
  }

  @ViewChild('viewer', { static: false }) viewer: ElementRef;

  wvInstance: any;
  showuploaddiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any) {
    this.showuploaddiv = true;



    WebViewer({
      path: '../../../wv-resources/lib',
      licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
      fullAPI: true,
      //  webViewerServer : true,
      disabledElements: [
        'leftPanelButton',
        'toolbarGroup-Annotate',
        'highlightToolGroupButton',
        'underlineToolGroupButton',
        'strikeoutToolGroupButton',
        'squigglyToolGroupButton',
        'freeTextToolGroupButton',
        'shapeToolGroupButton',
        'stickyToolGroupButton',
        'freeHandToolGroupButton',
        'toolsOverlay',
        'eraserToolButton',
        'redoButton',
        'stickyToolButton',
        'textPopup',
        'toggleNotesButton',
        'selectToolButton',
        'highlightToolButton',
        'freeHandToolButton',
        'freeTextToolButton',
        'toolsHeader',
        'printButton',

      ]
    }, this.viewer.nativeElement).then((instance: any) => {
      this.wvInstance = instance;

      instance.UI.disableElements(['printButton']);
      instance.UI.disableFeatures([instance.UI.Feature.Print]);

      // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
      instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          if (e.ctrlKey && e.key.toLowerCase() === 'p') {
            e.preventDefault();
            e.stopPropagation();
            alert('Printing is disabled.');
          } else {
            e.preventDefault();
            e.stopPropagation();
          }
          return false;
        });
      });

      instance.UI.setTheme('dark');
      instance.print = false;

      instance.UI.disableElements(['toolbarGroup-Shapes']);
      instance.UI.disableElements(['toolbarGroup-Edit']);
      instance.UI.disableElements(['toolbarGroup-Insert']);
      instance.UI.disableElements(['menuButton']);
      instance.UI.disableElements(['undoButton']);
      instance.UI.disableElements(['highlightToolGroupButton']);

      if (extn != null) {
        instance.UI.loadDocument(data.body, { extension: extn });
      }

      const { documentViewer } = instance.Core;
      documentViewer.addEventListener('documentLoaded', () => {
        console.log("doc loaded");
      });

      const UIEvents = instance.UI.Events;
      instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
        console.log(err);
      });

      instance.Core.documentViewer.addEventListener('documentLoaded')
    })

  }

  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  toggleAllSelection(value: any) {
    if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
  }

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.isAllColumns = this.selectedColumns.length == this.dropDownForReport.length;
      });
    }
  }

  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }

  onDeSelect() {
    this.onSelect();
  }

  onSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  onDeSelectAll(item: any[]) {
    if (item.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(item);
  }

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }


  downloadExcelReport(data: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadexcel(data).subscribe({
      next: (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    })
  }

  downloadPdfReport(pdfData: any, fileName: string) {

    this.isProcessing = true;
    this.appService.downloadPdf(pdfData).subscribe({
      next: (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = globalThis.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (fileName)
          downloadLink.setAttribute('download', fileName);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  public onFocusEmpty(): void {
    console.log();
  }

}
